import {
	SET_FORM_STATE,
	GET_OPT_OVERALL_TRACKER,
	TOGGLE_OPT_OVERALL_DIALOG,
	GET_OPT_OVERALL_TRACKER_DETAILS,
	GET_OPT_OVERALL_TRACKER_DROPDOWNS,
	TOGGLE_DELETE_OPT_OVERALL_DIALOG
} from '../actions/OptOverallActions';

const initialState = {
	incidents: [],
	optOverallDialogVisibility: false,
	incidentDetails: [],
	dropdowns: [],
	optimizationsOverallDto: [],
	tableId: '',
	deleteOptOverallDialogVisibility: false,
	autocompleteFields: [],
	formState: {
		values: {
		},
		isValid: false,
		touched: {},
		errors: {},
	},
};

const optOverallReducer = (state = initialState, action) => {
	switch (action.type) {
					case SET_FORM_STATE: {
						return {
							...state,
							formState: action.formState
						};
					}
					case GET_OPT_OVERALL_TRACKER: {
						return {
							...state,
							incidents: action.incidents
						};
					}
					case TOGGLE_OPT_OVERALL_DIALOG: {
						return {
							...state,
							optOverallDialogVisibility: action.visible,
							tableId: action.tableId,
							formState: initialState.formState
						};
					}
					case GET_OPT_OVERALL_TRACKER_DETAILS: {
						return {
							...state,
							formState: {
								...state.formState,
								values: { ...action.incidentDetails }
							}
						};
					}
					case GET_OPT_OVERALL_TRACKER_DROPDOWNS: {
						return {
							...state,
							dropdowns: action.dropdowns
						};
					}
					case TOGGLE_DELETE_OPT_OVERALL_DIALOG: {
						return {
							...state,
							deleteOptOverallDialogVisibility: action.visible,
							tableId: action.tableId,
						};
					}
					default: {
						return state;
					}
	}
};

export default optOverallReducer;
